<style scoped>
  .comment-words >>> textarea.ivu-input{height: 128px;margin: 40px 0 24px 0;resize:none}
  .art{height: 36px;width: 36px;border-radius: 18px;background-color: #00a2e9;font-size: 18px;color: #ffffff;text-align: center;line-height: 34px;cursor: pointer;}
  .comment-content{color: #525866;font-size: 14px;text-indent:1em;line-height: 40px}
</style>

<template>
  <div>
    <!--时间、内容-->
    <Row>
      <Col span="24" style="border-bottom: 1px solid #d7dde4;font-size: 0;padding-bottom: 10px" v-for="(item,index) in list">
        <Col span="24" style="color: #00a2e9;font-size: 14px;font-weight: bold;padding-top: 22px">{{item.date}}</Col>
        <template v-for="(secItem,secIndex) in item.children">
          <Col span="24" class="comment-content">
            <!--<Col span="6">{{secItem.time}}</Col>-->
            <Col span="4">{{secItem.name}}</Col>
            <Col span="20">{{secItem.content}}</Col>
          </Col>
        </template>
      </Col>
    </Row>
  </div>
</template>

<script>
  export default {
    name: "history",//历史记录
    data() {
      return {
        commitText:'',
        list:[],
      }
    },
    methods:{
      getHistory:function () {
        var _this = this
        _this.send({
          headers:'C/MissionHistory',
          data:{
            CaseId: _this.$route.query.caseId,
            MissionId:_this.$route.query.taskId,
          },
          success:function (res) {
            var i = 0
            for(var index in res.list){
              _this.$set(_this.list,i,{})
              _this.$set(_this.list[i],'date',index)
              _this.$set(_this.list[i],'children',[])
              var j = 0
              for(var secIndex in res.list[index]){
                _this.$set(_this.list[i].children,j,{})
                _this.$set(_this.list[i].children[j],'time',res.list[index][secIndex].MissionUpdateTime)
                _this.$set(_this.list[i].children[j],'name',res.list[index][secIndex].UserName)
                _this.$set(_this.list[i].children[j],'content',res.list[index][secIndex].MissionUpdateContent)
                // _this.$set(_this.list[i].children[j],'id',res.list[index][secIndex].MessageId)
                j++
              }
              i++
            }
          }
        })
      },
    },
    mounted:function () {
      this.getHistory()
    }
  }
</script>

